import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ContentSections } from '../components/ContentSections';
import { MechanismSection } from '../components/MechanismSection';
import { OfferSection } from '../components/OfferSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#0f1b2d] overflow-x-hidden font-sans selection:bg-[#25D366] selection:text-[#0f1b2d]" data-id="element-315">
      <HeroSection data-id="element-316" />
      <ContentSections data-id="element-317" />
      <MechanismSection data-id="element-318" />
      <OfferSection data-id="element-319" />
    </main>;
}